export default {
  "custom": {
    linkedReference: 'Referensi tertaut',
    boot: 'Nyala',
    shutDown: 'Matikan',
    notLinked: 'Tidak tertaut',
    maxLinkedTip: 'Maksimal 2 tautan {type} diizinkan, otomatis dikembalikan ke Tidak tertaut',

    bar_Power: 'Kontrol daya',
    bar_Video: 'Saklar video',
    bar_Vol: 'Volume',
    bar_Audio: 'Saklar audio',
    bar_Serial: 'Kendali serial',
    bar_Air: 'Pendingin udara',
    bar_Projection: 'Layar proyeksi',
    bar_Remote: 'Remote control',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Anda harus memilih ketiga gambar secara bersamaan',
    notSelected: 'Belum dipilih',
    choose: 'Pilih',
    disable: 'Nonaktifkan',
    "longPressAndDrag": "Tekan lama dan seret untuk menyesuaikan urutan daftar",
    "isrestoreDefault": "Apakah Anda ingin mengembalikan ke keadaan default?",
    "saveAndSync": "Simpan dan sinkronkan",
    "restoreDefault": "Pulihkan ke default",
    "limitPNG": "Hanya gambar PNG yang dapat diunggah!",
    "limit1M": "Ukuran gambar tidak boleh melebihi 1MB!",
    "selectTheImage": "Pilih gambar",
    "textsuggestions": "Disarankan: ikon PNG putih 48*48 px, kurang dari 1MB",
    "iconLibrary": "Perpustakaan ikon",
    "panelNavigationBarCustomization": "Bilah navigasi panel",
    "logoCustomization": "Logo panel"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Gagal menghubungkan: Penyewa Microsoft ini (ID: ',
    AuthVerify4004Two: ') sudah digunakan oleh organisasi [',
    AuthVerify4004Three: ']. Untuk menghubungkan kembali, harap lepaskan dari organisasi asli atau gunakan penyewa Microsoft lain.',
    theMicrosoftTenantIsOccupied: 'Penyewa Microsoft sedang digunakan',
    Viewtutorial: 'Lihat tutorial pengikatan',
    checktenantID: 'Harap periksa apakah ID penyewa, ID aplikasi, dan kunci aplikasi Anda sudah benar.',
    ErrorCode: 'Kode error:',
    AuthorizationFailed: 'Otorisasi gagal',
    Accesshasbeengranted: 'Akses ke Microsoft Graph API telah diberikan',
    successfullyauthorizedDescribe: 'Izin yang diperlukan telah berhasil diberikan. Data ruang rapat akan disinkronkan secara otomatis. Harap tutup halaman ini.',
    Close: 'Tutup',
    resourceID: 'ID sumber daya',
    dialogTips: 'Tips',
    theAuthorizationIsDeleted: 'Otorisasi dihapus',
    theBindingIsSuccessful: 'Pengikatan berhasil',
    theUnbindingIsSuccessful: 'Pelepasan ikatan berhasil',
    unbindingFailed: 'Pelepasan ikatan gagal',
    theUnbindingHasBeenUnbound: 'Pelepasan ikatan dibatalkan',
    continueUnbinding: 'Sinkronisasi Outlook akan berhenti dan semua acara mendatang akan dihapus. Lanjutkan pelepasan ikatan?',
    areYouSureAboutUnbinding: 'Semua acara Outlook mendatang akan dihapus dan sinkronisasi akan berhenti. Tindakan ini tidak dapat dibatalkan. Konfirmasi pelepasan ikatan?',
    UnbindNotSynchronized: 'Setelah pengikatan, acara Outlook baru untuk ruangan ini akan disinkronkan secara otomatis (acara sebelumnya tidak akan disinkronkan)',
    unbinding: 'Lepaskan ikatan',
    bindUnableToSelect: 'Sudah terikat, tidak dapat dipilih',
    permissAThird: 'Harap berikan otorisasi untuk mengikat sumber daya pihak ketiga',
    resourceMailbox: 'Kotak surat sumber daya:',
    PleasecheckID: 'Otorisasi gagal! Harap periksa apakah ID penyewa, ID aplikasi, dan rahasia klien Anda sudah benar.',
    Waitingforauthorization: 'Menunggu otorisasi...',
    Pleasecompletetheauthorization: 'Halaman login Microsoft 365 telah terbuka. Harap masuk dengan akun admin untuk menyelesaikan otorisasi.',
    pleaseEnterTheTenantID: 'Masukkan ID penyewa',
    pleaseEnterTheClientID: 'Masukkan ID aplikasi',
    pleaseEnterTheClientSecret: 'Masukkan rahasia klien',
    Authorizationcompleted: 'Otorisasi selesai',
    Authorizelogin: 'Otorisasi login Microsoft 365',
    ApplicationID: 'ID penyewa',
    ClientID: 'ID aplikasi',
    ClientSecret: 'Rahasia klien',
    registTipOne: 'Harap ikuti',
    registTipTwo: 'Panduan pengikatan',
    registTipThree: 'Lengkapi pendaftaran aplikasi Azure dan pengaturan izin sebelum mengisi kolom di bawah ini.',
    MicrosoftDescribe: 'Dengan mengikat Microsoft 365, rapat yang dipesan di Outlook/Teams akan otomatis disinkronkan ke Konsol Q-NEX dan Penjadwal Ruangan.',
    Addcalendarservice: 'Pengaturan sinkronisasi kalender',
    Lasttimesynchronization: 'Waktu sinkronisasi terakhir',
    Allocated: 'Dialokasikan',
    Total: 'Total',
    Conferenceroomresources: 'Sumber daya ruang rapat',
    Bindingtime: 'Waktu pengikatan',
    Bindtheplatform: 'Platform pengikatan',
    Synchronousstate: 'Status sinkronisasi',
    Organizationname: 'Nama organisasi',
    Bindthirdpartycalendar: 'Ikat kalender pihak ketiga',
    TenantIDTip: 'Pengidentifikasi unik di Azure AD',
    ApplicationIDTip: 'ID aplikasi yang terdaftar di Azure',
    ApplicationSecretTip: 'Rahasia klien yang dibuat di Azure untuk autentikasi'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Teks Tampilan Tidak Aktif',
    IdleDisplayText: 'Teks Tampilan Tidak Aktif:',
    IdleDisplayTextContent: 'Teks yang ditampilkan saat ruangan kosong (default: “Kosong”)',

    duplicateMeetingRoomName: 'Nama ruang rapat duplikat',
    duplicateMeetingRoomNameContent: 'Ruang rapat dengan nama "{duplicate_content}" sudah ada. Silakan gunakan nama lain.',
    NumberOfRoomPanels: 'Jumlah panel ruangan',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Terminal saat ini sudah terhubung ke organisasi lain.",
    "theTerminalNameOrIDIsDuplicated": "Nama atau ID panel sama",
    theRoomNameOrIDIsDuplicated: 'Nama ruang rapat atau lokasi sudah ada.',
    "AddMeetingRoom": "Tambahkan ruang rapat",
    "EditMeetingRoom": "Edit ruang rapat",
    "MeetingRoomName": "Nama ruang rapat:",
    "Location": "Lokasi:",
    "ReservationApproval": "Persetujuan pemesanan:",
    "ApprovalListYes": "ya",
    "ApprovalListNo": "tidak",
    "Capacity": "Kapasitas:",
    "RoomStatus": "Status ruang:",
    "BindRoomDisplay": "Ikat panel ruang:",
    "meeting_btnAdd": "Tambah",
    "meeting_btnEdit": "Edit",
    "meeting_btnBind": "Ikat perangkat",
    "meeting_btnDel": "Hapus",
    "meeting_tableRoomName": "Nama ruang rapat",
    "meeting_tableRoomPlace": "Lokasi",
    "meeting_tableAppointmentApproval": "Persetujuan pemesanan",
    "meeting_tableCapacityForPeople": "Kapasitas",
    "meeting_tableMeetingRoomStatus": "Status ruang",
    "meeting_tableAvaliable": "Tersedia",
    "meeting_tableOutofService": "Tidak berfungsi",
    "meeting_tableDoorBind": "Ikat pintu",
    "meeting_tableBindNPS": "Ikat NPS",
    "meeting_tableActions": "Tindakan",
    "door_theNameOfTheTerminal": "Nama panel:",
    "door_deviceID": "ID panel:",
    "door_Wallpaper": "Wallpaper:",
    "door_Wallpaper_text": "Ukuran gambar yang disarankan: 1280x800, dalam format PNG",
    "door_bindAMeetingRoom": "Ikat ruang rapat:",
    "door_table_name": "Nama panel",
    "door_table_deviceID": "ID panel",
    "door_table_status": "Status",
    "door_table_ipAddress": "Alamat IP",
    "door_table_bindAMeetingRoom": "Ikat ruang rapat",
    "door_btnAdd": "Tambah",
    "door_btnBatchAdd": "Tambah secara massal",
    "door_btnEdit": "Edit",
    "door_btnBatchEdit": "Edit secara massal"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Tambahkan konfigurasi",
    "configurationEditTitle": "Edit konfigurasi",
    "dialogConfigName": "Nama konfigurasi",
    "selectNMPAndNDP": "Perangkat target",
    "powerControl": "Kontrol daya",
    "executeCommand": "Lakukan",
    "tableConfigName": "Nama konfigurasi",
    "selectConfig": "Silakan pilih konfigurasi"
  },
  "NPS": {
    "Relay": "Relay",
    "RelaySettings": "Pengaturan Relay",
    "DevicePower": "Kontrol daya perangkat",
    "DeviceElevation": "Kontrol elevasi",
    "LinageWithNPSPower": "Tautkan dengan daya NPS",
    "PresentationSwitch": "Sakelar presentasi",
    "Duplicate": "Duplikat",
    "LinkagewithNPSPowe": "Tautkan dengan daya NPS"
  },
  "PTZ": {
    "powerSupplyON": "Nyalakan",
    "powerSupplyOFF": "Matikan",
    "LEFT": "Kiri",
    "RIGHT": "Kanan",
    "UP": "Atas",
    "DOWN": "Bawah",
    "HOME": "Beranda",
    "ENLARGE": "Perbesar",
    "REDUCTION": "Perkecil",
    "StopMovement": "Berhenti bergerak",
    "STOP": "Berhenti zoom",
    "FOCUS": "Fokus",
    "SET_PRESETS0": "ATUR_PRESET0",
    "SET_PRESETS1": "ATUR_PRESET1",
    "SET_PRESETS2": "ATUR_PRESET2",
    "SET_PRESETS3": "ATUR_PRESET3",
    "SET_PRESETS4": "ATUR_PRESET4",
    "SET_PRESETS5": "ATUR_PRESET5",
    "SET_PRESETS6": "ATUR_PRESET6",
    "SET_PRESETS7": "ATUR_PRESET7",
    "SET_PRESETS8": "ATUR_PRESET8",
    "SET_PRESETS9": "ATUR_PRESET9",
    "USE_PRESETS0": "GUNAKAN_PRESET0",
    "USE_PRESETS1": "GUNAKAN_PRESET1",
    "USE_PRESETS2": "GUNAKAN_PRESET2",
    "USE_PRESETS3": "GUNAKAN_PRESET3",
    "USE_PRESETS4": "GUNAKAN_PRESET4",
    "USE_PRESETS5": "GUNAKAN_PRESET5",
    "USE_PRESETS6": "GUNAKAN_PRESET6",
    "USE_PRESETS7": "GUNAKAN_PRESET7",
    "USE_PRESETS8": "GUNAKAN_PRESET8",
    "USE_PRESETS9": "GUNAKAN_PRESET9"
  },
  "schedule": {
    "startLinkPowerStart": "Nyalakan (Relay CBXs)  ",
    "startLinkPowerStop": "Matikan (Relay CBXs)  ",
    "dehumidification": "Kering  ",
    "airSupply": "Kipas  ",
    "masterControl": "Utama:  ",
    "powerSupply": "Daya  ",
    "lockScreen": "Kunci  ",
    "RecordingControl": "Kontrol Perekaman  ",
    "RecordingControlSystem": "Sistem Rekaman Kuliah  ",
    "LiquidCrystal": "Panel Interaktif Layar Datar  ",
    "projector": "Proyektor  ",
    "othertype": "Lainnya  ",
    "childLock": "Kunci Anak  ",
    "energySaving": "Hemat Energi  ",
    "signalSourceSwitching": "Sumber Masukan  ",
    "other": "Fitur Lain:  ",
    "otherFunction": "Fungsi  ",
    "send": "Kirim  ",
    "ON": "NYALAKAN  ",
    "OFF": "MATIKAN  ",
    "btnAddSchedule": "Pulihkan  ",
    "EditSchedulelist": "Edit Penjadwal  ",
    "AddSchedulelist": "Tambah Penjadwal  ",
    "RestoreSchedulelist": "Pulihkan  ",
    "btn": "Batal  ",
    "btnNewList": "Penjadwal Baru  ",
    "ListName": "Nama  ",
    "Cannotquit": "Wajib  ",
    "NOCannotquit": "TIDAK  ",
    "ListValidityPeriod": "Periode Validitas  ",
    "ListDescription": "Deskripsi  ",
    "currentSchedule": "Daftar Penjadwal  ",
    "historySchedule": "Daftar Riwayat  ",
    "selectTime": "Waktu  ",
    "taskType": "Jenis Tugas  ",
    "selectBroadcasting": "Siaran  ",
    "selectDeviveControl": "Kontrol Perangkat  ",
    "newSchedule": "Tugas Baru  ",
    "newChecklist": "Daftar Periksa Baru  ",
    "titleStatus": "Status  ",
    "titleType": "Jenis  ",
    "titleStartTime": "Waktu Mulai  ",
    "titleEndTime": "Waktu Selesai  ",
    "titleRepeat": "Ulangi  ",
    "titleName": "Nama  ",
    "titleAction": "Tindakan  ",
    "tableEnabled": "Diaktifkan  ",
    "tablePaused": "Dijeda  ",
    "tableEdit": "Edit  ",
    "tableDelete": "Hapus",
    "tableVolumeEdit": "Volume Siaran  ",
    "tableBroadcastTitle": "Judul  ",
    "tableBroadcastContent": "Konten  ",
    "tableBroadcastList": "Daftar  ",
    "tableBroadcast": "Kompulsif  ",
    "btnRemoveCompletely": "Hapus sepenuhnya  ",
    "btnEnabled": "Diaktifkan  ",
    "btnPaused": "Ditangguhkan  ",
    "btnDelete": "Hapus  ",
    "repeat0": "SEN  ",
    "repeat1": "SEL  ",
    "repeat2": "RAB  ",
    "repeat3": "KAM  ",
    "repeat4": "JUM  ",
    "repeat5": "SAB  ",
    "repeat6": "MIN  ",
    "dialogTitleAdd": "Tugas Kontrol Perangkat Baru  ",
    "dialogTitleEdit": "Edit Tugas Kontrol Perangkat  ",
    "newBroadcastingSchedule": "Tugas Siaran Baru  ",
    "editBroadcastingSchedule": "Edit Tugas Siaran  ",
    "chooseDevice": "Pilih Perangkat  ",
    "timeSetting": "Pengaturan Waktu  ",
    "controlBroadcasting": "Opsi Siaran  ",
    "controlOption": "Opsi Kontrol  ",
    "scheduleName": "Nama Tugas:  ",
    "destination": "Tujuan  ",
    "timeTilte": "Waktu  ",
    "repeatTitle": "Ulangi  ",
    "dialogRepeat0": "SEN  ",
    "dialogRepeat1": "SEL  ",
    "dialogRepeat2": "RAB  ",
    "dialogRepeat3": "KAM  ",
    "dialogRepeat4": "JUM  ",
    "dialogRepeat5": "SAB  ",
    "dialogRepeat6": "MIN  ",
    "dialogOnceType": "Sekali  ",
    "dialogRepeatType": "Ulangi  ",
    "mainPower": "Daya Utama  ",
    "powerControl": "Kontrol Daya  ",
    "tableDisplayInputSwitch": "Saklar Input Tampilan  ",
    "tableAirConditioning": "AC  ",
    "tableProjectionScreen": "Layar Proyeksi  ",
    "tableElectronicLock": "Kunci Listrik  ",
    "interactiveFlatPanel": "Panel Interaktif Layar Datar  ",
    "displayInputSwitch": "Saklar Input Tampilan  ",
    "speakerVolume": "Volume Speaker  ",
    "MICVolume": "Volume MIC  ",
    "ProjectionScreen": "Layar Proyeksi  ",
    "ElectronicLock": "Kunci Listrik  ",
    "AirConditioning": "AC",
    "AirConditioningPower": "Kekuatan  ",
    "AirConditioningModel": "Model  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Kecepatan kipas  ",
    "OPEN": "BUKA  ",
    "CLOSE": "TUTUP  ",
    "UP": "ATAS  ",
    "DOWN": "BAWAH  ",
    "PowerOFF": "MATI  ",
    "PowerON": "HIDUP  ",
    "ModelAuto": "Otomatis  ",
    "ModelCool": "Pendingin  ",
    "ModelHeat": "Pemanas  ",
    "ModelAir": "Sisi udara  ",
    "TEMPLow": "Rendah  ",
    "TEMPMiddle": "Sedang  ",
    "TEMPHigh": "Tinggi  ",
    "btnSave": "Simpan  ",
    "btnNext": "BERIKUTNYA  ",
    "StartTime": "Waktu mulai  ",
    "StopTime": "Waktu berhenti  ",
    "Mandatory": "Wajib  ",
    "Video": "Video & Audio  ",
    "Notification": "Notifikasi  ",
    "btnFile": "Pilih file media  ",
    "LastingTime": "Durasi  ",
    "textTitle": "Judul  ",
    "textContent": "Konten  ",
    "textTitleLetters": "Kurang dari 60 huruf  ",
    "textContentLetters": "Kurang dari 320 huruf  ",
    "CannotquitYES": "YA  ",
    "CannotquitNo": "Tidak  ",
    "YES": "YA  ",
    "No": "Tidak  ",
    "delTitleContent": "Apakah Anda yakin ingin menghapus penjadwal ini?  ",
    "delTitleListContent": "Penjadwal yang dihapus akan dipindahkan ke daftar riwayat dan dapat dipulihkan  ",
    "deleListTitle": "Hapus penjadwal?  ",
    "delTitleListContent1": "Menghapus penjadwal ini akan menyebabkan tugas terkait dihapus, harap konfirmasi.  ",
    "deleListTitle1": "Apakah Anda yakin ingin menghapus penjadwal ini?  ",
    "delTitle": "Hapus?  ",
    "btnConfirm": "Konfirmasi  ",
    "coxAll": "SEMUA  ",
    "coxBroadcasting": "Penyiaran  ",
    "coxDeviveControl": "Kontrol Perangkat  ",
    "rdMandatory": "YA  ",
    "noRdMandatory": "TIDAK  ",
    "startDate": "Tanggal mulai  ",
    "endedDate": "Tanggal selesai  ",
    "or": "-  ",
    "broadcastingType": "Tipe",
    "ChooseTime": "Pilih waktu  ",
    "ChooseDate": "Pilih tanggal  ",
    "newScheduleList": "Jadwal baru  ",
    "editScheduleList": "Edit jadwal  ",
    "listName": "Nama  ",
    "listValidityPeriod": "Periode validitas  ",
    "listDescription": "Deskripsi  ",
    "cancel": "Batal  ",
    "confirm": "Konfirmasi  ",
    "save": "Simpan  ",
    "addSuccess": "Berhasil ditambahkan!  ",
    "addError": "Gagal menambahkan!  ",
    "editSuccess": "Berhasil diedit!  ",
    "editError": "Gagal mengedit!  ",
    "delSuccess": "Berhasil dihapus!  ",
    "delError": "Gagal menghapus!  ",
    "restoreSuccess": "Daftar jadwal berhasil dipulihkan  ",
    "restoreError": "Gagal memulihkan daftar jadwal  ",
    "restoreTitleContent": "Waktu ini bertabrakan dengan jadwal dalam daftar, harap pilih lagi  ",
    "Enabled": "Diaktifkan  ",
    "Paused": "Ditangguhkan  ",
    "Title": "Judul:  ",
    "Content": "Konten:  ",
    "errorScheduleNameRequired": "Nama tugas harus diisi  ",
    "errorDeviceRequired": "Silakan pilih perangkat tujuan  ",
    "deleTitle": "Apakah Anda yakin ingin menghapus tugas ini?  ",
    "loopList": "Daftar loop  ",
    "errorPleaseDateRange": "Silakan pilih rentang tanggal  ",
    "addError_2009": "Nama jadwal duplikat  ",
    "conflicts": "Waktu tugas bertabrakan dengan yang berikut:  ",
    "Pleaseagain": "Silakan masukkan lagi  ",
    "errorScheduleName": "Nama tugas  ",
    "errorListName": "Nama jadwal  ",
    "today": "Hari ini  ",
    "yesterday": "Kemarin  ",
    "thisWeek": "Minggu ini  ",
    "lastWeek": "Minggu lalu  ",
    "lastMonth": "Bulan lalu  ",
    "thisMonth": "Bulan ini  ",
    "times": "Kali  ",
    "TimeConflicts": "Konflik waktu  ",
    "editError_2006": "Perangkat tidak ditemukan  ",
    "editError_2010": "Nama tugas duplikat  ",
    "ListTimeExpired": "Waktu jadwal telah kedaluwarsa, harap pilih lagi  ",
    "TimeExpired": "Waktu kedaluwarsa  ",
    "ControlOption": "Opsi kontrol hilang  ",
    "Pleaseleastone": "Silakan pilih setidaknya satu opsi kontrol  ",
    "Enter": "Masukkan  ",
    "TitleFilled": "Judul harus diisi  ",
    "ContentFilled": "Konten harus diisi  ",
    "PleaseMediaFile": "Silakan pilih file media  ",
    "PleaseSchedule": "Silakan pilih tugas  ",
    "delTitleScheduleContent": "Tugas yang dihapus tidak dapat dipulihkan.  ",
    "deleTitleSchedule": "Apakah Anda yakin ingin menghapus tugas ini?  ",
    "deleteScheduleTitle": "Silakan pilih tugas untuk dihapus  ",
    "PleaseFillColumn": "Silakan isi nama penjadwal  ",
    "PleaseDate": "Silakan pilih tanggal  ",
    "Previous": "Sebelumnya  ",
    "RemoteControl": "Kontrol jarak jauh  ",
    "taskhasexpired": "Tugas ini telah kedaluwarsa, harap hubungi pembuat untuk memperbarui waktu.  ",
    "execute": "Eksekusi  ",
    "broadcastingList": "Daftar siaran  ",
    "volumeSuccess": "Volume berhasil diatur  ",
    "volumeFailed": "Gagal mengatur volume  "
  },
  "Automation": {
    "nameDuplicate": "Nama tugas duplikat otomatis  ",
    "Automation": "Automatisasi  ",
    "if": "Jika:  ",
    "ifContent": "Bagian 'Jika' memungkinkan Anda untuk mengatur kondisi berdasarkan data sensor. Pilih sensor dan tentukan kondisi seperti 'Suhu > 26°C'.  ",
    "then": "Maka:  ",
    "thenContent": "Bagian 'Maka' memungkinkan Anda memilih perangkat dan menentukan tindakan untuknya. Pilih perangkat seperti NMP1, NMP2 dan tentukan tindakan seperti 'Nyalakan + Dingin' untuk AC.  ",
    "btnDelete": "Hapus  ",
    "Add": "Tambah  ",
    "taskName": "Nama tugas  ",
    "dialogTaskName": "Nama tugas:  ",
    "Statue": "Status  ",
    "DevicesApplied": "Perangkat yang diterapkan  ",
    "Operation": "Operasi  ",
    "AirConditioningPower": "Daya  ",
    "AirConditioningModel": "Model  ",
    "AirConditioningFanSpeed": "Kecepatan kipas  ",
    "bold": "Ayunan  ",
    "selectTask": "Silakan pilih tugas  ",
    "autoTaskAdd": "Tambahkan tugas otomatisasi  ",
    "autoTaskEdit": "Edit tugas otomatisasi  ",
    "Destination": "Tujuan  ",
    "selectConditions": "Silakan tentukan tindakan yang ingin Anda lakukan  ",
    "selectDestination": "Silakan pilih perangkat NMP target, lalu tentukan tindakan yang ingin Anda lakukan  ",
    "AirConditioningTEMP": "Suhu  ",
    "AirConditioningHumidness": "Kelembapan  ",
    "noData": "Belum ada tugas yang ditambahkan. Klik tombol \"Tambah\" untuk menambahkan tugas  "
  },
  "rs232Translation": {
    "reliveBinding": "Lepaskan  ",
    "RELIVEBINDING": "Lepaskan",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Nama CBX tidak boleh kosong  ",
    "BrandNoNull": "Merek tidak boleh kosong  ",
    "ModelNoNull": "Model tidak boleh kosong  ",
    "AcNoNull": "Kontrol AC tidak boleh kosong  ",
    "RcNoNull": "Kontrol Jarak Jauh tidak boleh kosong"
  },
  "route": {
    customize: 'Sesuaikan',
    "InputSourcesLinkage": "Tautan Sumber Masukan  ",
    "Automation": "Automasi  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Grup  ",
    "userMge": "Pengguna  ",
    "authorityMge": "Izin  ",
    "roleMge": "Peran  ",
    "equipmentMge": "Perangkat  ",
    "workstationMge": "Server Media",
    "cloudDiskMge": "Penyimpanan",
    "operationLog": "Log Operasi  ",
    "setting": "Pengaturan  ",
    "resourceMge": "Manajemen Sumber Daya  ",
    "storageMge": "Manajemen Penyimpanan  ",
    "interfaceRename": "Ganti Nama Antarmuka  ",
    "processorManager": "Manajer Prosesor  ",
    "projectorCode": "Manajemen Kode Seri  ",
    "projectorCodeSetting": "Pengaturan Kode Seri  ",
    "RepairLog": "Log Perbaikan  ",
    "remoteControl": "Kode Remote Control  ",
    "acCode": "Kode Kontrol AC  ",
    "cardMge": "Kartu  ",
    "cardLog": "Log Penggunaan Kartu  ",
    "cardManager": "Manajer Kartu  ",
    "meetingManager": "Rapat  ",
    "meetingRoomManager": "Manajemen Ruang  ",
    "meetingDoorManager": "Manajemen Panel"
  },
  "navbar": {
    "logOut": "Keluar  ",
    "dashboard": "Dasbor  ",
    "screenfull": "Layar penuh  ",
    "language": "Bahasa  ",
    "userConsole": "Konsol Q-NEX  ",
    "BackTianwa": "Kembali ke Tianwa"
  },
  "feedback": {
    "Feedback": "Umpan Balik  ",
    "email": "Silakan tinggalkan email Anda untuk umpan balik kami.  ",
    "content": "Selamat datang dan tinggalkan pesan untuk meningkatkan produk kami. Terima kasih atas komentar Anda.  ",
    "submit": "Kirim  ",
    "emailNoEmpty": "Email tidak boleh kosong  ",
    "emailTrueRule": "Silakan masukkan format email yang benar  ",
    "contentNoEmpty": "Konten tidak boleh kosong  ",
    "feedbackSuccess": "Umpan balik berhasil  ",
    "feedbackFailed": "Umpan balik gagal  ",
    "emailNoChinese": "Kotak surat tidak boleh mengandung karakter Cina  ",
    "emailLength": "Panjang antara 5 dan 100 karakter  ",
    "GroupNameLength": "Panjang antara 1 dan 20 karakter  ",
    "emailSpecialString": "Kotak input ini tidak dapat mengandung string khusus"
  },
  "login": {
    "title": "SELAMAT DATANG  ",
    "logIn": "Masuk  ",
    "username": "Nama pengguna  ",
    "password": "Kata sandi  ",
    "any": "apapun  ",
    "thirdparty": "Atau hubungkan dengan  ",
    "thirdpartyTips": "Tidak dapat disimulasikan di lokal, jadi harap gabungkan simulasi bisnis Anda sendiri!!!  ",
    "placeholder": "[  \n  \"Nama pengguna\",  \n  \"Kata sandi\",  \n  \"Kode verifikasi\"  \n]  ",
    "userNameTitle": "Nama pengguna salah!  ",
    "forget": "Lupa?  ",
    "loginTitle0": "Masuk berhasil!  ",
    "loginTitle1000": "Nama pengguna atau kata sandi salah!  ",
    "loginTitle1001": "Nama pengguna dan kata sandi harus diisi!  ",
    "loginTitle1002": "Kode verifikasi harus diisi!  ",
    "loginTitle1003": "Status pengguna tidak sah, login gagal!  ",
    "loginTitle1004": "Kesalahan kode verifikasi!  ",
    "loginTitle1005": "Belum login, harap login terlebih dahulu!  ",
    "loginTitleUserName": "Nama pengguna harus diisi!  ",
    "loginTitlePwd": "Kata sandi harus diisi!  ",
    "loginTitleVercode": "Kode verifikasi harus diisi!  ",
    "errorLogin": "Hak pengguna tidak mencukupi, tidak dapat login!  ",
    "titleLoginNameFormat": "Harus terdiri dari karakter, atau karakter dan angka."
  },
  "organizationMge": {
    "CanTDragTop": "Tidak dapat pindah ke root  ",
    "prefixCannotBeEmpty": "Prefiks akun super administrator tidak boleh kosong  ",
    "enterEnglishLetters": "Prefiks akun super administrator hanya boleh berisi huruf Inggris dan angka  ",
    "dateNotSelected": "Tanggal mulai masa berlaku layanan streaming tidak dipilih  ",
    "btnAddChild": "Tambah bawahan  ",
    "btnAddSibling": "Tambah saudara  ",
    "title": "Tips:  ",
    "againTitle": "Harap konfirmasi lagi:  ",
    "sort": "Urutkan:  ",
    "realName": "Nama asli:  ",
    "titleShooleRq": "Kolom ini harus diisi  ",
    "titleShooleNub": "kurang dari 100 karakter  ",
    "schoolName": "Nama grup:  ",
    "type": "Jenis grup:  ",
    "accountPrefix": "Akun administrator:  ",
    "organization": "Distributor  ",
    "terminalMechanism": "Pengguna akhir  ",
    "equipmentNum": "Nomor perangkat:  ",
    "organizationNum": "Jumlah grup terminal:  ",
    "adminName": "Akun administrator:  ",
    "adminPwd": "Kata sandi administrator:  ",
    "edit": "Sunting  ",
    "add": "Tambah  ",
    "del": "Hapus  ",
    "addSuccess": "Tambah berhasil  ",
    "addError": "Tambah gagal!  ",
    "editSuccess": "Sunting berhasil  ",
    "editError": "Sunting gagal!  ",
    "delSuccess": "Hapus berhasil!  ",
    "delWarn": "Tidak dapat menghapus grup ini dengan perangkat yang terikat  ",
    "delError": "Hapus gagal!  ",
    "cancel": "Batal  ",
    "confirm": "Konfirmasi  ",
    "save": "Simpan  ",
    "TrialWorkstation": "Anda saat ini berada dalam status percobaan yang hanya dapat melakukan siaran langsung dan streaming ke maksimal 3 perangkat terminal.  ",
    "Normal": "Normal  ",
    "NormalWorkstation": "Periode berlaku layanan streaming Anda dari  ",
    "to": "hingga  ",
    "Advent": "Advent  ",
    "AdventWorkstationOne": "Layanan streaming Anda akan berakhir pada  ",
    "AdventWorkstationTwo": ", silakan hubungi agen Anda untuk memperbarui tepat waktu untuk penggunaan normal.  ",
    "Expired": "Kedaluwarsa  ",
    "ExpiredWorkstation": "Layanan streaming Anda telah kedaluwarsa, silakan hubungi agen Anda untuk memperbarui tepat waktu.  ",
    "admin": "Administrator:  ",
    "serviceState": "Layanan media streaming:  ",
    "serviceStateLIST": "Layanan media streaming  ",
    "ValidityPeriod": "Periode Validitas:  ",
    "ValidityPeriodLIST": "Periode Validitas  ",
    "Trial": "Percobaan  ",
    "Permanent": "Permanen  ",
    "AnnualBilling": "Penagihan Tahunan  ",
    "mediaValidityPeriod": "Periode Validitas:  ",
    "mediaValidityPeriodLIST": "Periode Validitas  ",
    "contactInformation": "Detail kontak (untuk pengingat pembaruan layanan streaming)  ",
    "company": "Nama Perusahaan:  ",
    "email": "Email:  ",
    "phone": "Telepon:  ",
    "StartDate": "Tanggal Mulai  ",
    "EndDate": "Tanggal Berakhir  ",
    "To": "Sampai  ",
    "TerminalName": "Nama Pengguna Akhir  ",
    "Competence": "Administrator  ",
    "operate": "Operasikan  ",
    "statusFilter": "Status Filter  ",
    "disableStreaming": "Apakah Anda yakin ingin menonaktifkan layanan streaming?  ",
    "enableStreaming": "Apakah Anda yakin ingin mengaktifkan layanan streaming?  ",
    "disableStreamingContent": "Saat layanan streaming dinonaktifkan, grup tidak akan dapat menggunakan fungsi terkait siaran dan siaran langsung.  ",
    "enableStreamingContent": "Silakan ubah periode validitas untuk grup dengan layanan streaming yang kedaluwarsa.  ",
    "search": "Masukkan nama organisasi  ",
    "optionsYearZero": "Silakan pilih",
    "optionsYearOne": "Satu tahun  ",
    "optionsYearTwo": "Dua tahun  ",
    "optionsYearThree": "Tiga tahun  ",
    "dialogName": "Nama:  ",
    "detTitle": "Menghapus grup akan menyebabkan semua konten di bawahnya terhapus juga.  ",
    "groupDelTitle": "Apakah Anda yakin ingin menghapus grup ini?  ",
    "delTitle": "Hapus?  ",
    "delTitleContent": "Konten yang dipilih akan dihapus dari database. Operasi ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?  ",
    "delCancelButton": "Batal  ",
    "delConfirmButton": "Konfirmasi  ",
    "copySuccess": "Konten telah disalin ke clipboard.  ",
    "copyError": "Peramban tidak mendukung salin otomatis  ",
    "error1200": "Nama grup duplikat  ",
    "error1201": "Duplikasi grup atau ID grup  ",
    "error1202": "Jumlah perangkat yang dapat dihubungkan telah melebihi batas  ",
    "error1203": "Nama pengguna duplikat  ",
    "error1204": "Sudah ada grup dengan nama yang sama pada level yang sama  ",
    "error1210": "Silakan masukkan kata sandi administrator  ",
    "warningGroup": "Pilih grup!  ",
    "warningTerminal": "Grup terminal tidak dapat membuat subgrup!  ",
    "account": "Akun duplikat  ",
    "titleOrganization": "Catatan: Awalan akun ditetapkan pada tingkat organisasi. Semua akun pengguna di dalam organisasi ini akan menggunakan awalan yang sama.",
    "all": "Semua"
  },
  "userMge": {
    "nickName": "Nama panggilan  ",
    "contentWithBrand": "Masukkan merek atau model  ",
    "contentwithIp": "Cari berdasarkan nama perangkat atau alamat IP.  ",
    "btnAdd": "Pengguna baru  ",
    "btnDelete": "Hapus  ",
    "btnDownload": "Unduh template  ",
    "btnImport": "Impor massal  ",
    "btnExport": "Unduh  ",
    "btnDisable": "Nonaktifkan  ",
    "btnEnable": "Aktifkan  ",
    "accountType": "Saring berdasarkan peran  ",
    "organizationName": "Saring berdasarkan grup  ",
    "content": "Cari  ",
    "systemAccount": "ID pengguna  ",
    "idCardNumber": "ID karyawan  ",
    "customizeAccount": "Akun kustom  ",
    "userName": "Nama  ",
    "licenseNum": "Nomor lisensi  ",
    "phone": "Telepon  ",
    "email": "Email  ",
    "role": "Peran  ",
    "status": "Status  ",
    "affiliatedOrganization": "Grup  ",
    "roleTypeList1": "Pengguna umum  ",
    "roleTypeList2": "Siswa  ",
    "roleTypeList3": "Orang tua  ",
    "roleTypeList101": "Admin Agen  ",
    "roleTypeList102": "Administrator  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Aktif  ",
    "userStatus2": "Blokir  ",
    "userStatus3": "Hapus  ",
    "operate": "Tindakan  ",
    "dialogName": "Nama panggilan:  ",
    "dialogUserName": "ID pengguna:  ",
    "dialogUserNameDefined": "Nama pengguna:  ",
    "dialogPassword": "Kata sandi:  ",
    "dialogID": "ID karyawan:  ",
    "dialogRole": "Peran:  ",
    "dialogEmail": "Email:  ",
    "dialogPhone": "Telepon:  ",
    "dialogGroup": "Grup:  ",
    "addUser": "Pengguna baru  ",
    "editUser": "Edit pengguna  ",
    "addSuccess": "Berhasil ditambahkan!  ",
    "addError": "Gagal ditambahkan!  ",
    "editSuccess": "Berhasil diedit!  ",
    "editError": "Gagal diedit!  ",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal Menghapus!  ",
    "cancel": "Batal  ",
    "confirm": "Konfirmasi  ",
    "save": "Simpan  ",
    "tableDel": "Hapus  ",
    "tableEdit": "Edit  ",
    "selectRoles": "Pilih Peran  ",
    "delTitle": "Hapus?  ",
    "delTitleContent": "Konten yang dipilih akan dihapus dari database. Operasi ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?  ",
    "delCancelButton": "Batal  ",
    "delConfirmButton": "Konfirmasi  ",
    "titleRealNameRq": "Kolom ini harus diisi  ",
    "titleRealNameFormat": "Pilih nama pengguna yang hanya berisi huruf dan angka  ",
    checkPasswordTitleTwo: 'Silakan buat kata sandi minimal 6 karakter, termasuk huruf dan angka. Karakter khusus diperbolehkan (tanpa batasan).',
    checkPasswordTitle: 'Kata sandi minimal 6 karakter dan tidak boleh hanya angka',
    "titlePhoneFormat": "Nomor telepon hanya dapat berisi angka, (), + dan -  ",
    "phoneFilled": "Nomor telepon harus diisi  ",
    "titleEmaileFormat": "Format email salah  ",
    "emaileFilled": "Email harus diisi  ",
    "titlUserNameDefinedNub": "Nama pengguna tidak boleh lebih dari 30 karakter  ",
    "titlRealNameNub": "Nama tidak boleh lebih dari 30 karakter  ",
    "titlRealNameField": "Nama harus diisi  ",
    "thisPasswordField": "Kata sandi harus diisi  ",
    "titlPassWordNub": "Kata sandi harus antara 6 hingga 30 karakter  ",
    "enableStatus": "Aktifkan pengguna  ",
    "stopStatus": "Nonaktifkan pengguna  ",
    "enableContent": "Apakah Anda yakin ingin mengaktifkan pengguna?  ",
    "stopContent": "Apakah Anda yakin ingin menonaktifkan pengguna?  ",
    "error1400": "Nama pengguna sudah ada, coba lagi  ",
    "error1401": "ID pengguna sudah ada, operasi gagal!  ",
    "error1402": "Grup tidak ada, impor gagal!  ",
    "error1403": "Data salah  ",
    "error1404": "Izin tidak cukup  ",
    "selUser": "Pilih pengguna!  ",
    "error1405": "Gagal mendapatkan peran  ",
    "error1406": "Format data pengguna yang diimpor salah  ",
    "error1407": "Email sudah ada dan operasi gagal  ",
    "error1408": "Nomor telepon sudah ada dan operasi gagal  ",
    "error1900": "Parameter yang diakses kosong  ",
    "error1610": "Silakan gunakan peran administrator terminal untuk melakukan operasi terkait  ",
    "errorOrgIdList": "Grup tidak bisa kosong!  ",
    "Bindsucceeded": "Berhasil menghubungkan  ",
    "Bindfailed": "Gagal menghubungkan  ",
    "tableuserName": "Nama pengguna  ",
    "titleDevice": "Perangkat  ",
    "bindDevice": "Perangkat yang terhubung  ",
    "Bindcontrollable": "Apakah ingin menghubungkan perangkat yang dapat dikendalikan sekarang?  "
  },
  "devicesMge": {
    mustChooseOne: 'Ketika kendali jarak jauh pintar dipilih, setidaknya satu perintah kontrol harus dipilih',
    customName: 'Nama kustom',
    "testAcCode": "Uji kode kontrol A/C baru",
    "Online": "Online",
    "Offline": "Offline",
    "unBindConfirm": "Konfirmasi untuk melepaskan Serial",
    "unBindConfirm485": "Konfirmasi untuk melepaskan RS485",
    "notYetBoundRS232": "Perangkat belum terhubung dengan kode Serial. Anda dapat pergi ke Perangkat > Kode Kontrol Serial untuk menambahkannya.",
    "RsFollowingFunctions": "Dapat melakukan fungsi berikut melalui kode Serial:",
    "Unbind": "Lepaskan",
    "Limit255": "Nama file mengandung maksimal 255 karakter",
    "clear": "Bersihkan",
    "equipName": "Nama perangkat",
    "equipType": "Tipe",
    "selectField": "Pilih file",
    "dialogTip": "*Jika kotak input di sebelah kanan kosong, konten di sebelah kiri ditampilkan secara default",
    "dialogTipSingle": "*Jika hanya satu perangkat yang tidak dinamai, ikuti nama \"SEMUA\"",
    "cantDelTemplateOne": "The CBX of ",
    cantDelTemplateTwo: 'CBX pada perangkat "{deviceName}" adalah template. Apakah Anda yakin ingin menghapusnya?',
    "templateTitle": "Penggantian template",
    "templateContentOne": "The device name \"",
    "templateContentTwo": "\" has been set as the common CBX template. Are you sure to set the current device as the template?",
    "vcbNoTemplateNoSave": "Tidak dapat menyimpan tanpa template",
    "vcbAcControl": "Pilih perangkat A/C",
    "vcbRemoteControl": "Pilih perangkat kontrol jarak jauh",
    "vcbPOWERControl": "Kontrol daya",
    "vcbRS232Control": "Kontrol Serial",
    "vcbIRControl": "Kontrol IR",
    "vcbSetting": "Pengaturan CBX",
    "editVcb": "Mengedit CBX",
    "vcbName": "Nama CBX",
    "iot": "Kontrol CBX",
    "saveAsTemplate": "Simpan sebagai template",
    saveAsTemplatereplenish: 'Pilih beberapa perangkat untuk menggunakan templat ini di Pusat Kontrol',
    "Upload": "Unggah",
    "Select": "Pilih",
    "InputDeviceID": "Masukkan ID perangkat",
    "editNameTips": "* Konten di sebelah kiri ditampilkan secara default saat kotak input di sebelah kanan kosong.",
    "_RS232A": "Antarmuka satu",
    "_RS232B": "Antarmuka dua",
    "institutionDirectory": "Direktori institusi",
    "projectionScreenLinkageSetting": "Pengaturan kontrol layar proyeksi",
    "screenLiftingLinkageDisplaySwitch": "Kontrol tautan layar proyeksi dan tampilan:",
    "stopLinkage": "Nonaktifkan (Kontrol layar proyeksi terpisah)",
    "Enable": "Aktifkan (Kontrol sinkron layar proyeksi dan tampilan)",
    "btnAddDevice": "Tambahkan perangkat",
    "btnImportDevice": "Impor perangkat massal",
    "btnDel": "Hapus",
    "btnEdit": "Edit",
    "tableIpAddress": "Alamat IP",
    "MACAddress": "Alamat MAC",
    "firmwareVersion": "Versi firmware",
    "NA": "Tidak tersedia",
    "tableDeviceName": "Nama perangkat",
    "tableStatus": "Status",
    "tableVideoSwitch": "Saklar video",
    "tableAudio": "Distribusi A/V",
    "tablePowerControl": "Kontrol daya",
    "tableRS232": "Kontrol serial",
    "tableIR": "Kontrol IR",
    "tableRFIDCard": "Kartu IC",
    "tableControlPanel": "Panel kontrol",
    "tableOrganization": "Grup",
    "tableActions": "Tindakan",
    "dialogAddTitle": "Tambah perangkat",
    "dialogEditTitle": "Edit perangkat",
    "dialogBatchAddTitle": "Tambah perangkat massal",
    "dialogBatchEditTitle": "Edit perangkat massal",
    "btnCancel": "Batal",
    "Devices": "Perangkat:",
    "ProjectorCode": "Kode Serial:",
    "Group": "Grup:",
    "btnBatchAdd": "Tambah massal",
    "delTitle": "Hapus?",
    "delTitleContent": "Komponen yang dipilih akan dihapus dari database. Proses ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "addError": "Gagal menambah!",
    "editSuccess": "Sukses mengedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Sukses menghapus!",
    "delError": "Gagal menghapus!",
    "content": "Cari",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "tableDel": "Hapus",
    "tableEdit": "Edit",
    "selectRoles": "Pilih peran",
    "selectType": "Silakan pilih jenis",
    "selectDevices": "Silakan pilih perangkat",
    "titleRealNameRq": "Kolom ini harus diisi",
    "titleRealNameNub": "Kurang dari 100 karakter",
    "titlPassWordNub": "Kurang dari 15 karakter",
    "error1900": "Parameter yang diakses kosong",
    "error2000": "Jumlah perangkat yang dapat terhubung telah melebihi batas maksimum",
    "error2001": "Kode perangkat yang diimpor salah atau belum dimasukkan ke dalam sistem",
    "error2002": "Nama perangkat yang diimpor duplikat",
    "error2003": "ID perangkat yang diimpor telah digunakan",
    "error2004": "Kesalahan data impor",
    "error2005": "Nama merek atau model duplikat dengan data yang sudah ada di sistem; silakan beri nama baru pada merek atau model.",
    "error2008": "Perangkat ini sudah terhubung dengan grup lain",
    "notDevicesName": "Nama perangkat tidak boleh kosong",
    "notDevicesNO": "ID perangkat tidak boleh kosong",
    "dialogDevicesName": "Nama perangkat:",
    "dialogDevicesID": "ID perangkat:",
    "dialogProjectorCode": "Kode Serial:",
    "dialogGroup": "Grup:",
    "dialogSel": "Silakan pilih",
    "errorOrgIdList": "Grup tidak boleh kosong!",
    "errorDevicesName": "Nama perangkat tidak boleh kosong!",
    "errorDevicesNo": "ID perangkat tidak boleh kosong!",
    "dialogTiltleDevices": "Perangkat:",
    "uploadSuccess": "Unggahan berhasil",
    "addSuccess": "Tambah berhasil",
    "ChooseGroups": "Pilih grup",
    "ChooseIcon": "Pilih ikon",
    "dialogDevicesTitle": "Pengaturan parameter diterapkan ke perangkat berikut",
    "backDevice": "Kembali",
    "bootSetting": "Opsi mulai",
    "nmpOpenSetting": "Pengaturan daya nyala",
    "npsOpenSetting": "Pengaturan daya nyala",
    "nmpPowerSettings": "Pengaturan daya",
    "npsPowerSettings": "Pengaturan daya",
    "nmpInterfaceSettings": "Pengaturan antarmuka",
    "npsInterfaceSettings": "Pengaturan antarmuka",
    "nmpDefaultChannel": "Pengaturan saluran default",
    "nmpCloseSetting": "Pengaturan daya mati",
    "npsCloseSetting": "Pengaturan daya mati",
    "SwipeToStart": "Aktifkan kunci (sentuh kartu untuk membuka kunci)",
    "ControlPanelToStart": "Nonaktifkan kunci (operasi tanpa batas)",
    "Display": "Tampilan",
    "External": "Eksternal",
    "startingUpMethod": "Aktifkan/nonaktifkan kunci panel:",
    "startWith": "Mulai dengan:",
    "nmpstartWith": "Daya nyala sinkron:",
    "nmpcloseWith": "Daya mati sinkron:",
    "RS232Tip": "Ketika daya utama dimatikan, total 5 antarmuka Serial, termasuk Serial dan hingga 4 CBX, akan menerima kode perintah matikan yang sesuai.",

    startPowerTip: 'Saat dinyalakan, semua perangkat yang terhubung ke port daya CBX akan diaktifkan secara bersamaan.',
    startAirTip: 'Saat dinyalakan, semua AC yang terhubung akan dinyalakan secara serempak melalui inframerah perangkat/CBX.',
    startIrTip: 'Saat dinyalakan, perintah sinkronisasi dikirim melalui inframerah perangkat/CBX (misal: tirai turun, proyektor menyala).',
    startRSTip: 'Saat dinyalakan, perintah nyalakan dikirim melalui port Serial perangkat/CBX.',
    CloseDisplayTip: 'Perangkat yang terhubung ke port DISPLAY akan mati otomatis saat NDP/NMP dimatikan. Pengaturan ini dikontrol oleh firmware dan tidak bisa diubah melalui perangkat lunak.',
    CloseExternalTip: 'Perangkat yang terhubung ke port EXTERNAL akan mati otomatis saat NDP/NMP dimatikan. Pengaturan ini dikontrol oleh firmware dan tidak bisa diubah melalui perangkat lunak.',
    ClosePowerTip: 'Saat dimatikan, semua perangkat yang terhubung ke port daya CBX akan dimatikan secara bersamaan.',
    CloseAirTip: 'Saat dimatikan, semua AC yang terhubung akan dimatikan secara serempak melalui inframerah perangkat/CBX.',
    CloseIrTip: 'Saat dimatikan, perintah sinkronisasi dikirim melalui inframerah perangkat/CBX (misal: tirai naik, proyektor mati).',
    CloseRSTip: 'Saat dimatikan, perintah matikan dikirim melalui port Serial perangkat/CBX.',
    npsOpenRS232Tip: 'Ketika catu daya utama dinyalakan, 2 antarmuka port serial NPS akan menerima kode perintah daya yang sesuai.',
    "npsRS232Tip": "Ketika daya utama dimatikan, dua antarmuka Serial di NPS akan menerima kode perintah matikan yang sesuai.",
    "useCardTip": "Setelah membuka kunci kartu, daya perangkat akan diaktifkan secara otomatis.",
    "npsCardTip": "Setelah membuka kunci kartu, daya utama perangkat akan diaktifkan secara otomatis.",
    "PowerOutageHandling": "Penanganan Pemadaman Daya",
    "PowerOutageHandTip": "Untuk melanjutkan akses saat terjadi pemadaman daya yang tidak terduga, pilih 'Buka Kunci saat Pemadaman Daya'. Jika tidak, pilih 'Kunci saat Pemadaman Daya' untuk membatasi akses.",
    "acSetting": "Pengaturan A/C",
    "ChooseType": "Jenis Perangkat",
    "ChooseBrand": "Pilih Merek",
    "ChooseModel": "Pilih Model",
    "btnConnectingTest": "Uji Koneksi",
    "LockSetting": "Pengaturan Kunci Listrik",
    "ElectricLockType": "Jenis Kunci Listrik:",
    "PowerUNLOCK": "Buka Kunci saat Pemadaman Daya",
    "PowerLOCK": "Kunci saat Pemadaman Daya",
    "none": "Tidak Ada",
    "oddParity": "Paritas Ganjil",
    "EvenParity": "Paritas Genap",
    "LastSetting": "Pengaturan Terakhir",
    "ElectricLockClosing": "Penutupan Kunci Listrik:",
    "manualSwitch": "Saklar Manual",
    "Auto": "Otomatis (di dalam)",
    "projectorSetting": "Pemilihan dan Pengikatan Perangkat",
    "baudRate": "Kecepatan Baud",
    "Parity": "Paritas",
    "ON": "Nyalakan",
    "OFF": "Matikan",
    "Channel1": "Saluran 1",
    "Channel2": "Saluran 2",
    "PowerOffDelay": "Tunda matikan daya",
    "second": "s",
    "DefaultChannel": "Saluran Default",
    "HDMIA": "HDMI keluar A:",
    "HDMIB": "HDMI keluar B:",
    "HDMIC": "HDMI keluar C:",
    "btnSaveApply": "Simpan dan terapkan ke...",
    "btnSave": "Simpan",
    "btnCustomize": "Kustom",
    "ACIsPowerTitle": "Periksa apakah A/C menyala?",
    "ACIsPowerContent": "Harap matikan A/C sebelum pengujian. Jika tidak menyala dengan sukses, pastikan merek dan model A/C sudah benar.",
    "btnNextModel": "Tidak, uji model berikutnya",
    "btnYes": "Ya",
    "errorConnecting": "Pengujian koneksi gagal",
    "hot": "PANAS",
    "_MAGNETICLOCK": "Kunci Elektronik",
    "_AIR": "Pendingin Udara",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Pengaturan Kontrol IR",
    "acControlTitle": "Pilih Perangkat A/C:",
    "acControlTitleNew": "Perangkat A/C",
    "intelligentControlTitle": "Pilih Perangkat Kontrol Jarak Jauh:",
    "intelligentControlTitleNew": "Perangkat Kontrol Jarak Jauh",
    "btnACControlCode": "Identifikasi kode kontrol A/C Baru",
    "btnAddRemoteControl": "Kode kontrol jarak jauh baru",
    "ACControlCodeTitle": "Identifikasi Kode kontrol A/C",
    "ACControlCodeseft1": "Identifikasi Kode",
    "ACControlCodeseft2": "Tambahkan informasi",
    "btnStartIdentify": "Mulai",
    "Identifysuccess": "Identifikasi berhasil!",
    "BeingIdentify": "Menganalisis...",
    "acBrand": "Merek A/C",
    "acModel": "Model A/C",
    "IdentifyFailureTitle": "Gagal menemukan kode",
    "IdentifyFailureContent": "Identifikasi gagal, model ini saat ini tidak didukung. Silakan coba dengan Remote Control",
    "btnTryAgain": "Coba lagi",
    "btnJump": "Pergi ke remote control",
    "ACrideo": "A/C",
    "ortherRideo": "Perangkat lain",
    "btnBack": "Kembali",
    "btnSortOut": "Pergi ke edit",
    "remoteControlSeft1": "Pilih tipe perangkat",
    "remoteControlSeft2": "Belajar kode",
    "remoteControlSeft3": "Tambahkan informasi",
    "addRemoteControlError": "Maaf, tidak dapat belajar lebih banyak kode. Harap edit kode remote control yang ada terlebih dahulu",
    "btnPrevious": "Sebelumnya",
    "btnNextStep": "Berikutnya",
    "remoteControlErrorTitle": "Gagal belajar kode",
    "remoteControlErrorContent1": "1. Pengirim inframerah tidak terblokir",
    "remoteControlErrorContent2": "2. Tidak ada gangguan cahaya kuat di sekitar penerima",
    "remoteControlErrorContent3": "3. Pengirim inframerah dipasang dengan benar",
    "remoteControlErrorContent4": "4. Remote control berfungsi dengan baik",
    "deviceItem1": "A/C",
    "deviceItem2": "Proyektor",
    "deviceItem3": "TV",
    "deviceItem4": "Kipas angin",
    "deviceItem5": "Lampu",
    "deviceItem6": "Lainnya",
    "deviceItem7": "Panel Interaktif",
    "deviceItem8": "Sistem Perekaman Kuliah",
    "deviceItem9": "Kamera PTZ",
    "RS232protocol": "Protokol Serial:",
    "btnRemoteControl": "Mulai belajar",
    "BeingIdentify1": "Menganalisis...",
    "Identifysuccess1": "Berhasil",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Kipas angin",
    "controllerType5": "Lampu",
    "controllerType9": "Lainnya",
    "rqRemoteControlCode": "Harap masukkan nama kode kontrol jarak jauh",
    "rqBrand": "Harap masukkan merek A/C",
    "rqModel": "Harap masukkan model A/C",
    "error2016": "Nama kontrol jarak jauh duplikat, harap masukkan nama lain",
    "RS232Setting": "Pengaturan kode serial",
    "IR232Setting": "Pengaturan IR",
    "SystemError": "Kesalahan sistem. Silakan coba lagi",
    "conditionerCodeContent": "Tidak dapat menemukan kode AC, silakan coba lagi",
    "remoteControlCodeContent": "Tidak dapat menemukan kode kontrol jarak jauh, silakan coba lagi",
    "btnRetry": "Coba lagi",
    "Bindusers": "Hubungkan pengguna",
    "tablebinduser": "Hubungkan pengguna",
    "Refresh": "Segarkan",
    "Binduserlable": "Hubungkan pengguna yang dapat mengontrol perangkat sekarang?",
    "SaveApplySuccessfully": "Simpan dan terapkan berhasil",
    "DeviceType": "Tipe:",
    "tableDeviceType": "Tipe",
    "empty": "Kosong.",
    "sendCommand": "Kirim nanti",
    "enable": "Aktifkan",
    "disable": "Nonaktifkan",
    "SYNCremoteControl": "SINKRONKAN dengan kontrol jarak jauh",
    "analysisfailed": "Analisis gagal, silakan coba lagi",

    "CBX": {
      "powerSupplyON": "Nyalakan",
      "powerSupplyOFF": "Matikan",
      "powerVcrON": "Mulai Merekam",
      "powerVcrOFF": "Hentikan Perekaman",
      "lockScreenON": "Kunci Aktif",
      "lockScreenOFF": "Kunci Nonaktif",
      "childLockON": "Kunci Anak Aktif",
      "childLockOFF": "Kunci Anak Nonaktif",
      "energySavingON": "Hemat Energi Aktif",
      "energySaving": "Hemat Energi",
      "energySavingOFF": "Hemat Energi Nonaktif",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Loudspeaker",
      "brightAdjustment": "Kecerahan",
      "other": "Fitur lainnya...",
      "volumeExample": "Fungsi kontrol Serial lengkap diperlukan untuk kompatibilitas penuh dengan sistem perekaman",
      "functionCode": "Fungsi:",
      "Name": "Nama:",
      "controlCode": "Kode Kontrol:",
      "brand": "Merek:",
      "model": "Model:",
      "errorBrandName": "Merek tidak boleh kosong!",
      "errorModelName": "Model tidak boleh kosong!"
    }

  },
  "roleMge": {
    "role1": "Pengguna umum",
    "role101": "Admin agen",
    "role102": "Administrator",
    "role4": "Peran kustom",
    "roleNew": "Peran baru",
    "btnAddRole": "Tambah peran",
    "chooseUser": "Pilih pengguna",
    "titleLevel": "Tingkat properti siaran:",
    "titleSettings": "Pengaturan izin:",
    "btnSave": "Simpan",
    "btnDelete": "Hapus",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "addSuccess": "Tambah berhasil!",
    "addError": "Gagal menambah!",
    "editSuccess": "Edit berhasil!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Hapus berhasil!",
    "delError": "Gagal menghapus!",
    "V3_0_OrganizationManage": "Manajemen grup",
    "V3_0_UserManage": "Manajemen pengguna",
    "V3_0_DeviceManage": "Manajemen perangkat",
    "V3_0_CloudSpaceManage": "Manajemen ruang cloud",
    "V3_0_OrganizationManage_View": "Lihat",
    "V3_0_OrganizationManage_Edit": "Edit",
    "V3_0_UserManage_View": "Lihat",
    "V3_0_UserManage_Edit": "Edit",
    "V3_0_DeviceManage_AddDevice": "Tambah perangkat",
    "V3_0_DeviceManage_Operating": "Operasikan",
    "V3_0_DeviceManage_Delete": "Hapus",
    "V3_0_DeviceManage_Edit": "Edit",
    "V3_0_CloudSpaceManage_PersonalManage": "Manajemen cloud pribadi",
    "V3_0_CloudSpaceManage_PublicManage": "Manajemen cloud publik",
    "V3_0_CloudSpaceManage_SpaceManage": "Penetapan ruang",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operasi",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Lihat",
    "V3_0_CloudSpaceManage_PublicManage_View": "Lihat",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Unggah",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Unduh",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Hapus file",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Edit folder",
    "delTitle": "Hapus?",
    "delTitleContent": "Konten yang dipilih akan dihapus dari database. Proses ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "btnAdd": "Tambah peran",
    "RoleName": "Nama peran:",
    "ManageRange": "Rentang manajemen:",
    "ChooseUser": "Pilih pengguna:",
    "PermissionSettings": "Pengaturan izin:",
    "BroadcastingPropertyLevel": "Tingkat properti penyiaran",
    "ChooseGroups": "Pilih grup",
    "ChooseTheUser": "Pilih pengguna",
    "deleleTitle": "Peran baru belum disimpan. Jika Anda keluar, peran akan dihapus. Apakah Anda yakin ingin keluar?",
    "Error1601": "Tidak dapat menggunakan administrator",
    "Error1602": "Gagal mendapatkan peran izin",
    "Error1603": "Hanya administrator yang dapat mengakses fitur ini",
    "Error1604": "Nama peran tidak boleh kosong",
    "Error1605": "Grup tidak boleh kosong",
    "Error1606": "Peran ini sudah ada",
    "Error1607": "Peran yang ditentukan oleh sistem, tidak dapat dimodifikasi",
    "Error1608": "Gagal mengatur peran",
    "Error1609": "Peran pengguna umum sistem, tidak dapat dimodifikasi",
    "Error1610": "Silakan gunakan peran administrator terminal untuk melakukan operasi terkait",
    "Error1611": "Tidak memiliki izin peran terkait"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Isi nama fungsi dan kode kontrol. Contoh kode kontrol menggunakan format HEX.",
    "tipTwo": "2. Antarmuka ini hanya untuk konfigurasi perintah serial nyala/mati. Silakan pergi ke 'Manajemen Perangkat / Perangkat / Operasi / Pengaturan Daya' untuk mengaktifkan fungsi.",
    "tipFunctionOne": "1. Pilih fungsi umum dari daftar tarik-turun. Ikon yang sesuai akan ditampilkan di antarmuka kontrol serial panel pintar.",
    "tipFunctionTwo": "2. Perintah 'POWER ON' dan 'POWER OFF' digunakan untuk tautan serial nyala/mati perangkat. Halaman ini hanya mengonfigurasi kode kontrol. Silakan pergi ke 'Manajemen Perangkat / Perangkat / Operasi / Pengaturan Daya' untuk mengaktifkan fungsi tautan.",
    "ListRS232functions": "Daftar Fungsi Kontrol Serial",
    "Customizefunctionlist": "Sesuaikan daftar fungsi",
    "btnAddProjectorCode": "Tambah Kode Serial",
    "btnDel": "Hapus",
    "inputSeach": "Cari",
    "btnEdit": "Edit",
    "cancel": "Bersihkan",
    "confirm": "Konfirmasi",
    "tableName": "Nama kode",
    "tablersType": "Jenis perangkat:",
    "tablersTypeTable": "Jenis perangkat",
    "tableModel": "Model",
    "tableBrand": "Merek",
    "tableActions": "Tindakan",
    "dialogAddTitle": "Tambah Kode Serial",
    "dialogEditTitle": "Edit Kode Serial",
    "brand": "Nama Merek:",
    "model": "Model:",
    "baudRate": "Kecepatan Baud:",
    "parity": "Paritas:",
    "powerOn": "NYALAKAN",
    "powerOff": "MATIKAN",
    "pgrInput1": "Saluran 1",
    "pgbInput2": "Saluran 2",
    "delTitle": "Hapus?",
    "delTitleContent": "Konten yang dipilih akan dihapus dari database. Proses ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "content": "Cari",
    "operate": "Tindakan",
    "tableDel": "Hapus",
    "tableEdit": "Edit",
    "addSuccess": "Berhasil Ditambahkan!",
    "addError": "Gagal Menambahkan!",
    "editSuccess": "Berhasil Diedit!",
    "editError": "Gagal Mengedit!",
    "delSuccess": "Berhasil Dihapus!",
    "delError": "Gagal Menghapus!",
    "selectTitle": "Silakan pilih Serial!",
    "selectCode": "Pilih Serial",
    "none": "Tidak Ada",
    "oddParity": "Paritas Ganjil",
    "EvenParity": "Paritas Genap"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Manajemen Grup",
    "V3_0_UserManage": "Manajemen Pengguna",
    "V3_0_DeviceManage": "Manajemen Perangkat",
    "V3_0_CloudSpaceManage": "Manajemen Ruang Cloud",
    "V3_0_OrganizationManage_View": "Lihat",
    "V3_0_OrganizationManage_Edit": "Edit",
    "V3_0_UserManage_View": "Lihat",
    "V3_0_UserManage_Edit": "Edit",
    "V3_0_DeviceManage_AddDevice": "Tambah Perangkat",
    "V3_0_DeviceManage_Operating": "Operasi",
    "V3_0_DeviceManage_Delete": "Hapus",
    "V3_0_DeviceManage_Edit": "Edit",
    "V3_0_DeviceManage_RepairLog": "Log Perbaikan",
    "V3_0_CloudSpaceManage_PersonalManage": "Manajemen Cloud Pribadi",
    "V3_0_CloudSpaceManage_PublicManage": "Manajemen Cloud Publik",
    "V3_0_CloudSpaceManage_SpaceManage": "Manajemen Ruang Cloud",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operasi",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Lihat",
    "V3_0_CloudSpaceManage_PublicManage_View": "Lihat",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Unggah",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Unduh",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Hapus",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Edit",
    "delTitle": "Hapus?",
    "delTitleContent": "Komponen yang dipilih akan dihapus dari database. Proses ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "content": "Cari",
    "operate": "Aksi",
    "tableDel": "Hapus",
    "tableEdit": "Edit",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambahkan!",
    "editSuccess": "Berhasil mengedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal menghapus!",
    "selectTitle": "Silakan pilih Serial!"
  },
  "workstationMge": {
    "priorChoice": "Preferensi Siaran:",
    "SpeedPriority": "Prioritas Kecepatan",
    "SyncPriority": "Prioritas Sinkronisasi Frame",
    "SpeedPriorityTip": "Setelah instruksi penyiaran AV dikirim, terminal Q-NEX dapat melakukan tugas pemutaran dalam waktu buffer yang lebih singkat sekitar 3-5 detik. Prioritas kecepatan sangat dianjurkan ketika Media Server bekerja di LAN.",
    "SyncPriorityTip": "Setelah instruksi penyiaran AV dikirim, terminal Q-NEX dapat melakukan tugas pemutaran secara sinkron dengan waktu buffer sekitar 8-12 detik.",
    "btnAddMedia": "Tambah Media Server",
    "btnBack": "Kembali",
    "tableMediaLibId": "ID Media Server",
    "tableMediaLibName": "Nama Media Server",
    "tableState": "Status Jaringan",
    "tableBindingUsers": "Pengguna yang Terikat",
    "tableLiveAddress": "Alamat Penyiaran",
    "tableAddress": "Alamat Streaming",
    "tableOperate": "Aksi",
    "tableDel": "Hapus",
    "tableEdit": "Edit",
    "titleMediaStation": "Alamat Penyiaran",
    "titleLiveStation": "Alamat Streaming:",
    "radioPublic": "Publik",
    "radioPrivate": "Pribadi",
    "btnSave": "Simpan",
    "titleUsers": "Pengguna",
    "titleCanBe": "Dapat Diikat",
    "titleHaveBeen": "Sudah Terikat",
    "titleMore": "Perlu menambah lebih banyak?",
    "btnAdd": "Tambah",
    "content": "Cari",
    "tableName": "Nama",
    "tableUserName": "Nama Pengguna",
    "operate": "Aksi",
    "affiliatedOrganization": "Grup",
    "dialogTitle": "Tambah server media baru",
    "dialogTitleEdit": "Edit server media baru",
    "dialogItemName": "Nama:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Alamat siaran:",
    "titleSelectUsers": "Pilih pengguna",
    "selectMedia": "Silakan pilih media",
    "delTitle": "Apakah Anda yakin ingin menghapus?",
    "delMediaLibTitle": "Konfirmasi penghapusan?",
    "delTitleContent": "Konten yang dipilih akan dihapus dari basis data. Proses ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delTitleMediaLibContent": "Tindakan penghapusan ini akan menghapus data yang relevan dan tidak dapat dibatalkan.",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "selectDevices": "Silakan pilih perangkat",
    "selectUser": "Silakan pilih pengguna",
    "addUser": "Tambah pengguna",
    "editUser": "Edit pengguna",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambahkan!",
    "editSuccess": "Berhasil diedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal menghapus!",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "error2500": "Jumlah perangkat yang dapat terhubung ke workstation saat ini telah melebihi batas maksimum.",
    "DeviceName": "Nama perangkat",
    "AssociatedUserManagement": "Manajemen pengguna terkait",
    "btnDel": "Hapus",
    "errorMsgId": "ID ini tidak dapat ditemukan",
    "LiveStreaming": "Alamat streaming:",
    "NoFoundMediaId": "Tidak dapat mendapatkan ID dari server media",
    "AlreadyConnectedOrg": "Server media sudah terhubung dengan organisasi lain",
    "AlreadyBoundMedia": "Organisasi ini sudah mengikat server media, dan tidak bisa mengikat lebih banyak lagi",
    "DeleteSecondaryConfirmation": "Data tidak dapat dipulihkan setelah menghapus server media, harap konfirmasi lagi."
  },
  "cloudDiskMge": {
    "totalStorage": "PENYIMPANAN TOTAL",
    "GetMore": "Dapatkan lebih banyak",
    "StorageSpace": "Ruang penyimpanan",
    "Adjustment": "Penyesuaian",
    "moreSpace": "Dapatkan lebih banyak ruang penyimpanan",
    "PublicStorage": "Penyimpanan publik",
    "PublicStorageUsed": "Penyimpanan publik yang digunakan",
    "PublicStorageLasted": "Penyimpanan publik yang tersisa",
    "IndividualStorageUsed": "Penyimpanan pribadi yang digunakan",
    "IndividualStorageLasted": "Penyimpanan pribadi yang tersisa",
    "storageSpace": "Penyesuaian ruang penyimpanan",
    "tableUserName": "Nama pengguna",
    "tableUsedSpace": "Ruang yang digunakan",
    "tableAvailableSpace": "Ruang yang tersedia",
    "tableActiveTime": "Waktu aktif terakhir",
    "tableOperate": "Tindakan",
    "cleanup": "Catatan untuk dibersihkan",
    "IndividualStorageSpaceAdjustment": "Penyesuaian ruang penyimpanan pribadi",
    "titleTotal": "Total",
    "PublicDisk": "Cloud publik",
    "IndividualDisk": "Cloud pribadi",
    "PerUser": "Per pengguna",
    "UsersInTotal": "Total pengguna",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambah!",
    "editSuccess": "Berhasil diedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal menghapus!",
    "error3000": "Operasi gagal karena ukuran total penyimpanan terlampaui.",
    "error3003": "Operasi gagal, harap periksa apakah server media telah diatur.",
    "IndividualStorage": "Penyimpanan pribadi",
    "NoteToCleanup": "Catatan untuk dibersihkan",
    "updatePersonalSuccess": "Ruang penyimpanan cloud Anda akan penuh, harap bersihkan tepat waktu",
    "updatePersonalSuccess1": "Berhasil dimodifikasi dan disimpan",
    "storageUsage": "Penggunaan penyimpanan pribadi",
    "bindIndividualstorage": "Pengguna yang diizinkan memiliki penyimpanan cloud pribadi",
    "UserIndividualstorage": "Pengguna yang sudah mengatur penyimpanan cloud pribadi",
    "Notificationsuccessfully": "Pemberitahuan berhasil dikirim",
    "Notificationfailed": "Pemberitahuan gagal dikirim",
    "tableName": "Nama",
    "userID": "ID pengguna"
  },
  "dashboard": {
    "exportPdf": "Ekspor PDF",
    "or": "-",
    "warrantyCompletionRate": "Tingkat perbaikan",
    "frequencyOfEachModule": "Persentase perbaikan untuk setiap modul fungsional",
    "repairHandling": "Status pemrosesan perbaikan",
    "sourceSwitchInput": "Saklar input",
    "micVol": "Volume mikrofon",
    "volumeSpeaker": "Volume speaker",
    "airAonditioner": "AC",
    "Curtain": "Layar proyektor",
    "remoteControlIntelligent": "Remote control",
    "RS232Control": "Kontrol Serial",
    "lockElectronic": "Kunci elektronik",
    "Repairreportcompleted": "Diperbaiki",
    "Totalnumberofrepairsreported": "Total perbaikan",
    "Warrantycompletionrate": "Tingkat penyelesaian perbaikan",
    "startDate": "Tanggal mulai",
    "endDate": "Tanggal selesai",
    "year": "Tahun",
    "month": "Bulan",
    "dayTian": "Hari",
    "placeholderDate": "Pilih Tanggal",
    "placeholderDateTime": "Pilih Waktu",
    "devicesNub": "Perangkat",
    "userNub": "Pengguna",
    "powerNub": "Daya (KW/H)",
    "storageUsed": "Penyimpanan yang digunakan (%)",
    "userLoginDevice": "Periode waktu aktif login pengguna",
    "devicePowerConsumption": "Konsumsi listrik harian untuk semua perangkat",
    "externalDeviceUsageTime": "Penggunaan perangkat eksternal",
    "equipmentRunningTime": "Penggunaan perangkat terminal",
    "cloudStorageSpace": "Penggunaan penyimpanan",
    "powerConsumptionPort": "Konsumsi daya untuk setiap port daya",
    "mostPopularFile": "File paling populer",
    "commonFunctions": "Fungsi yang sering digunakan",
    "commonlyUsed": "Metode penyiaran yang paling umum",
    "fileName": "Nama file",
    "usageCount": "Jumlah penggunaan",
    "electricityConsumption": "Konsumsi listrik",
    "publicStorageUsed": "Penyimpanan publik yang digunakan",
    "publicStorageLasted": "Penyimpanan publik yang tersisa",
    "individualStorageUsed": "Penyimpanan individu yang digunakan",
    "individualStorageLasted": "Penyimpanan individu yang tersisa",
    "notification": "Pemberitahuan",
    "audioBroadcast": "Penyiaran audio",
    "videoBroadcast": "Penyiaran video",
    "ac": "AC",
    "hDMISwitch": "Penyambung HDMI",
    "powerControl": "Kontrol daya",
    "powercontrol": "Kontrol daya",
    "Lock": "Kunci",
    "volumeAdjust": "Penyesuaian volume",
    "projectionScreen": "Layar proyeksi",
    "today": "Hari ini",
    "yesterday": "Kemarin",
    "thisWeek": "Minggu ini",
    "lastWeek": "Minggu lalu",
    "lastMonth": "Bulan lalu",
    "thisMonth": "Bulan ini",
    "times": "Kali",
    "usage": "Jumlah penggunaan",
    "eachrTitle": "Menit",
    "total": "Total",
    "NMPSystemissue": "Masalah sistem NMP",
    "displayPower": "Masalah perangkat eksternal NMP",
    "externalPower": "Masalah sistem MBX",
    "screen": "Masalah perangkat eksternal MBX",
    "TotalRepairs": "Total perbaikan",
    "Repaired": "Diperbaiki",
    "Unrepaired": "Belum diperbaiki",
    "day": "HARI",
    "Minutes": "Menit",
    "powerConsumption": "Menit",
    "Date": "Tanggal",
    "kw": "KW",
    "month1": "SEN",
    "month2": "SEL",
    "month3": "RAB",
    "month4": "KAM",
    "month5": "JUM",
    "month6": "SAB",
    "month7": "MIN",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Apr",
    "enmonth5": "Mei",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Agu",
    "enmonth9": "Sep",
    "enmonth10": "Okt",
    "enmonth11": "Nov",
    "enmonth12": "Des",
    "noData": "Tidak ada data"
  },
  "input": {
    "fivedigits": "Silakan masukkan angka positif dalam 5 digit",
    "titlUserNameField": "Nama pengguna ini harus diisi",
    "thisField": "Kolom ini harus diisi",
    "ChooseGroup": "Pilih grup",
    "placeholder": "Pilih",
    "placeholder_type": "Silakan pilih jenis kontrol perangkat",
    "titlRealNameField": "Kata sandi harus diisi",
    "thisPasswordField": "Kata sandi harus diisi",
    "titlPassWordNub": "Kurang dari 15 huruf",
    "Post": "Hanya angka",
    "passwordNoChinese": "Kolom input ini tidak dapat diisi dengan karakter Cina"
  },
  "transfer": {
    "all": "Semua",
    "Choose": "Pilih",
    "Selected": "Terpilih",
    "Subordinate": "Bawahan"
  },
  "setting": {
    limitPngGif: 'Hanya mendukung format PNG / GIF',
    limit3M: 'Ukuran gambar tidak boleh melebihi 3MB',
    setting_door_Wallpaper_text: 'Ukuran gambar yang disarankan: 1280x800, format PNG atau GIF',

    "reduction": "Pemulihan",
    "limitJpg": "Gambar profil yang diunggah hanya dapat dalam format PNG!",
    "limit2M": "Ukuran gambar profil yang diunggah tidak boleh melebihi 2MB!",
    "choseFile": "Pilih file",
    "textOne": "1. Gambar LOGO yang disarankan: ukuran 117*40, dalam format PNG",
    "textTwo": "2. Setelah diunggah, harap pergi ke Panel Sentuh, pastikan bahwa Panel Sentuh terhubung ke Internet, lalu klik logo asli untuk menyegarkannya.",
    "customizeLogo": "Pengaturan Logo Panel Sentuh",
    "addSuccess": "Pengaturan berhasil!",
    "settingIp": "Pengaturan alamat IP penyimpanan file",
    "ServerIP": "Alamat IP server:",
    "ServerPort": "Port server:",
    "btnSave": "Simpan",
    "TimeZoneSetting": "Pengaturan zona waktu",
    "CurrentTime": "Waktu saat ini:",
    "CurrentTimeZone": "Zona waktu saat ini:",
    "httpsSetting": "Penyimpanan file:",
    "utcName": "Waktu Standar Greenwich UTC/GMT",
    "utc0": "Waktu Standar Greenwich, Inggris Raya, Lisboa, Torshavn, London, Dublin, Edinburgh",
    "utc0_5": "",
    "utc1": "Eropa Tengah, Afrika Barat, Afrika Tengah Barat, Jerman, Irlandia, Prancis, Amsterdam, Italia, Berlin, Roma, Spanyol, Praha, Belgrade, Brussel, Paris, Madrid, Tunisia, Gabon, Maroko",
    "utc1_5": "",
    "utc2": "Eropa Timur, Afrika Tengah, Turki, Israel, Afrika Selatan, Istanbul, Kairo, Athena, Damaskus",
    "utc2_5": "",
    "utc3": "Afrika Timur, Rusia, Baghdad, Kuwait, Moskow, St. Petersburg",
    "utc3_5": "Iran",
    "utc4": "Abu Dhabi, Tbilisi, Dubai, Mauritius, Port Louis",
    "utc4_5": "Afganistan",
    "utc5": "Pakistan, Turkmenistan, Maladewa, Uzbekistan, Armenia, Tajikistan India, Mumbai, New Delhi, Bangalore, Kolkata",
    "utc5_5": "India, Sri Lanka",
    "utc6": "Novosibirsk, Kirgistan, Bangladesh, Bhutan",
    "utc6_5": "Kepulauan Cocos Australia, Vietnam",
    "utc7": "Thailand, Bangkok, Hanoi, Jakarta",
    "utc7_5": "",
    "utc8": "Cina, Malaysia, Filipina, Singapura, Taiwan China, Makau China, Hong Kong China",
    "utc8_5": "",
    "utc9": "Jepang, Korea Selatan, Tokyo, Seoul, Sapporo, Osaka, Timor Timur",
    "utc9_5": "Waktu Standar Tengah Australia",
    "utc10": "Australia, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papua Nugini",
    "utc10_5": "Pulau Lord Howe dari New South Wales, Australia",
    "utc11": "Kepulauan Solomon, Pulau Sakhalin",
    "utc11_5": "Pulau Norfolk, Australia",
    "utc12": "Selandia Baru, Auckland, Wellington, Fiji, Selandia Baru, Nauru",
    "utc12_5": "",
    "utc13": "Tanjung Verde, Azores",
    "utc13_5": "",
    "utc14": "Georgia Selatan, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brasil, Santiago, El Salvador, Brasilia, Uruguay, Argentina, Suriname",
    "utc15_5": "Waktu Standar Newfoundland",
    "utc16": "Venezuela, Bolivia, Paraguay, Chili",
    "utc16_5": "Venezuela",
    "utc17": "Waktu Timur (AS dan Kanada), Kolombia, Toronto, Ekuador, Peru, Kuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Waktu Tengah AS dan Kanada, Kota Meksiko, Monterrey, Chicago, Houston, New Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Waktu Pegunungan, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Waktu Pasifik, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Polinesia Prancis, Kepulauan Marquesas",
    "utc22": "Hawaii",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Nama perangkat:",
    "Time": "Waktu:",
    "startDate": "Tanggal mulai",
    "endedDate": "Tanggal selesai",
    "or": "-",
    "Problem": "Masalah:",
    "btnSearch": "Cari",
    "tableNO": "Tidak",
    "tableDeviceName": "Nama perangkat",
    "tableGroup": "Grup",
    "tableStatus": "Status",
    "tableDeliveredTime": "Waktu pengiriman",
    "tableSubmitter": "Pengirim",
    "tableUpdatingTime": "Waktu pembaruan",
    "tableProblem": "Masalah",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Balasan Admin",
    "tableAttachment": "Lampiran",
    "state0": "Terkirim",
    "state1": "Dalam proses",
    "state2": "Selesai",
    "Problem100": "SEMUA",
    "Problem0": "Masalah sistem",
    "Problem1": "Masalah perangkat eksternal",
    "ProblemType": "",
    "ProblemType0": "Kontrol daya",
    "ProblemType1": "Saklar HDMI",
    "ProblemType2": "Mikrofon",
    "ProblemType3": "Speaker",
    "ProblemType4": "AC",
    "ProblemType5": "Layar proyektor",
    "ProblemType6": "Kunci elektronik",
    "ProblemType7": "Siaran A/V",
    "ProblemType8": "Kontrol IR",
    "ProblemType9": "Kontrol Serial",
    "dialogDeviceName": "Nama perangkat",
    "dialogDeviceID": "ID perangkat",
    "dialogGroup": "Grup",
    "dialogSubmitter": "Pengirim",
    "dialogStatus": "Pilih status",
    "dialogProblem": "Masalah",
    "dialogNotes": "Catatan",
    "dialogRepairation": "Perbaikan",
    "dialogInProcess": "Dalam proses",
    "dialogCompleted": "Selesai",
    "editSuccess": "Edit berhasil!",
    "editError": "Gagal mengedit!",
    "problemRequired": "Silakan pilih jenis masalah",
    "detailRequired": "Silakan jelaskan masalah secara rinci",
    "statusRequired": "Silakan pilih status log",
    "btnCancel": "Batalkan",
    "DeliveredTime": "Waktu pengiriman",
    "UpdatingTime": "Waktu pembaruan",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Balasan Admin",
    "Note": "Catatan",
    "Detail": "Detail",
    "controlPanel": "Panel kontrol",
    "DeviceType": "Tipe",
    "dialogDeliveredTime": "Waktu pengiriman",
    "Submitter": "Pengirim"
  },
  "remoteControl": {
    "QuickActionName": "Nama",
    "DeviceType": "Tipe",
    "Description": "Deskripsi",
    "tableDescription": "Deskripsi",
    "editRemoteControl": "Edit Kode Remote Control",
    "QuickActionNameInput": "Nama",
    "DescriptionInput": "Deskripsi",
    "save": "Simpan",
    "Brand": "Merek",
    "Model": "Model",
    "EditACControlCode": "Edit Kode Kontrol AC",
    "acBrand": "Merek AC",
    "acModel": "Model AC"
  },
  "card": {
    "btnAddCard": "Tambah Kartu  ",
    "btnBatchAddCard": "Tambah Kartu Secara Massal  ",
    "tableCard": "Nomor Kartu  ",
    "tableState": "Status  ",
    "tableUser": "Ikat Pengguna  ",
    "tableID": "Nama pengguna",
    "tableType": "Jenis Kartu  ",
    "tableFfective": "Tanggal Kedaluwarsa  ",
    "dialogCard": "Nomor Kartu:  ",
    "dialogState": "Status:  ",
    "dialogUser": "Ikat Pengguna:  ",
    "dialogID": "Nama pengguna:  ",
    "dialogType": "Jenis Kartu:  ",
    "dialogFfective": "Tanggal Kedaluwarsa:  ",
    "dialogRemarks": "Keterangan:  ",
    "dialogAddTitle": "Tambah Kartu  ",
    "dialogEidtTitle": "Edit Kartu  ",
    "code2201": "Format periode kedaluwarsa kartu salah  ",
    "code2202": "Kartu ini sudah terikat  ",
    "code2203": "Pengguna ini sudah terikat  ",
    "code2204": "Kartu ini tidak terikat",
    "mastCard": "Kartu Master  ",
    "regularCard": "Kartu Umum  ",
    "permanent": "Permanen  ",
    "coxPermanent": "Permanen  ",
    "coxTime": "Dalam periode waktu tertentu  ",
    "tableDeviceName": "Nama Perangkat  ",
    "tableDeviceID": "ID Perangkat  ",
    "tableOperating": "Operasi  ",
    "tableOperatingTime": "Waktu Operasi  ",
    "tableCardID": "Nomor Kartu  ",
    "tableCardType": "Jenis Kartu  ",
    "tabluserName": "Nama Pengguna  ",
    "tabluserId": "ID Pengguna  ",
    "unlockPanel": "Panel Pembuka  ",
    "unlock": "Pintu Pembuka  ",
    "conAll": "Semua  ",
    "btnEnable": "Aktifkan  ",
    "btnDisable": "Nonaktifkan  ",
    "enableSuccess": "Berhasil diaktifkan  ",
    "stopSuccess": "Berhasil dinonaktifkan",
    "enableError": "Gagal mengaktifkan  ",
    "stopError": "Gagal menonaktifkan  ",
    "batchCard": "Nomor Kartu Batch:  ",
    "titlCardField": "Nomor kartu tidak boleh kosong  ",
    "titlCardFieldFormat": "Hanya huruf dan angka  ",
    "dialogBachAddTitle": "Tambahkan Kartu Batch",
    "pleaseTryAgain1": "Nomor kartu salah (NO. :",
    "pleaseTryAgain2": "), silakan coba lagi"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/id.js